import { Link } from "react-router-dom";
import { scrolleZu } from "@/lib/scroll";

const links = [
  { label: "Warum wir", href: "#warum" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "Ablauf", href: "#ablauf" },
  { label: "Projekte", href: "#projekte" },
  { label: "Bewertungen", href: "#bewertungen" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Footer() {
  const go = (e, href) => {
    e.preventDefault();
    scrolleZu(href, { duration: 1.6 });
  };
  return (
    <footer
      data-testid="footer"
      className="relative z-10 border-t border-white/5 bg-[#050505]/80 px-6 py-12 backdrop-blur-xl md:px-14"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 md:flex-row md:items-center">
        <a href="#" onClick={(e) => go(e, 0)} className="flex items-baseline gap-2" data-testid="footer-logo">
          <span className="gold-text font-serif-accent text-3xl leading-none">S&F</span>
          <span className="text-[10px] tracking-[0.4em] text-[#BDBDB6]">WEBDESIGN</span>
        </a>
        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`footer-link-${l.href.slice(1)}`}
              className="text-xs tracking-[0.18em] text-[#BDBDB6] transition-colors hover:text-[#FFD700]"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <Link
            to="/impressum"
            data-testid="footer-link-impressum"
            className="text-xs tracking-[0.18em] text-[#BDBDB6] transition-colors hover:text-[#FFD700]"
          >
            Impressum
          </Link>
          <Link
            to="/datenschutz"
            data-testid="footer-link-datenschutz"
            className="text-xs tracking-[0.18em] text-[#BDBDB6] transition-colors hover:text-[#FFD700]"
          >
            Datenschutz
          </Link>
          <p className="text-xs font-light text-[#8A8A84]">
            © 2026 S&F Webdesign · Webdesign für Augsburg, Königsbrunn, Gersthofen, Neusäß,
            Stadtbergen und Friedberg — mit Liebe zum Detail gefertigt.
          </p>
        </div>
      </div>
    </footer>
  );
}
